import { render, staticRenderFns } from "./PostContainer.vue?vue&type=template&id=54cb6946&scoped=true&"
import script from "./PostContainer.vue?vue&type=script&lang=js&"
export * from "./PostContainer.vue?vue&type=script&lang=js&"
import style0 from "./PostContainer.vue?vue&type=style&index=0&id=54cb6946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb6946",
  null
  
)

export default component.exports